import React, { useState, useEffect, useReducer } from "react";
import {
  Row,
  Col,
  Card,
  Typography,
  Button,
  message,
  Divider,
  Input,
  Tooltip,
  Form,
  Modal,
  Select,
  Space,
  InputNumber,
  DatePicker,
  Dropdown,
} from "antd";
import {
  EditOutlined,
  PlusOutlined,
  DeleteOutlined,
  BarsOutlined,
  ScheduleOutlined,
  RedoOutlined,
  UserOutlined,
  MoreOutlined,
  FileDoneOutlined,
} from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate } from "react-router-dom";
import http from "../../../services/http";
import { TableCustom } from "../../../components/table";
import { reducerRegister } from "../../../helpers/reducers";
import dayjs from "dayjs";
const { Text } = Typography;

// STATUS
const options_status = [
  { value: 0, label: "Finalizado" },
  { value: 1, label: "Ativo" },
  { value: -1, label: "Inativo" },
];

const array_status = {
  ["0"]: "Finalizado",
  ["1"]: "Ativo",
  ["-1"]: "Inativo",
};

export const EleicoesCipaCadastro = ({ to }) => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [dados, dispatch] = useReducer(reducerRegister, []);

  const [showModal, setShowModal] = useState(false);
  const [modal, contextHolder] = Modal.useModal();

  // ID ALTERAÇÃO
  const [idAlt, setIdAlt] = useState(0);

  useEffect(() => {
    listarEleicoes();
  }, []);

  // LISTAR
  const listarEleicoes = async () => {
    setLoading(true);
    const api = await http("get", `v1/eleicoes_cipa_eleicoes/listar`, []);
    if (api.statusCode === 200) {
      dispatch({ type: "LOAD", payload: api?.response?.data });
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CADASTRAR
  const cadastrarEleicao = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/eleicoes_cipa_eleicoes/adicionar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro cadastrado com sucesso!");
      setShowModal(false);
      resetForm();
      if (api?.response?.data) dispatch({ type: "ADD", payload: api?.response?.data });
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // ALTERAR
  const alterarEleicao = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/eleicoes_cipa_eleicoes/alterar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro alterado com sucesso!");
      setShowModal(false);
      resetForm();
      if (api?.response?.data) dispatch({ type: "UPDATE", payload: api?.response?.data });
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CARREGAR
  const carregarEleicao = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/eleicoes_cipa_eleicoes/carregar/${id}`, []);

    if (api.statusCode === 200) {
      setShowModal(true);
      resetForm();
      form.setFieldsValue({
        descricao: api.response.data.descricao,
        ano: api.response.data.ano,
        data_inicio: dayjs(api.response.data.data_inicio),
        data_fim: dayjs(api.response.data.data_fim),
        status: api.response.data.status,
      });
      setIdAlt(api.response.data.id);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // DELETAR
  const deletarEleicao = async (id) => {
    setLoading(true);
    const api = await http("post", `v1/eleicoes_cipa_eleicoes/deletar`, { id: id });
    if (api.statusCode === 200) {
      message.success("Registro deletado com sucesso!");
      dispatch({ type: "DELETE", payload: { id: id } });
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // GERAR ELEITORES
  const gerarEleitores = async (id) => {
    setLoading(true);
    const api = await http("post", `v1/eleicoes_cipa_eleicoes/gerar_eleitores`, { id: id });
    if (api.statusCode === 200) {
      message.success("Eleitores gerados com sucesso!");
      dispatch({ type: "UPDATE", payload: api?.response?.data });
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // RESET FORM
  const resetForm = () => {
    form.resetFields();
    setIdAlt(0);
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: "Descrição",
      dataIndex: "descricao",
    },
    {
      title: "Ano",
      dataIndex: "ano",
    },
    {
      title: "Data Início",
      dataIndex: "data_inicio",
      render: (_, e) => dayjs(e.data_inicio).format("DD/MM/YYYY"),
      renderText: (e) => dayjs(e.data_inicio).format("DD/MM/YYYY"),
    },
    {
      title: "Data Fim",
      dataIndex: "data_fim",
      render: (_, e) => dayjs(e.data_fim).format("DD/MM/YYYY"),
      renderText: (e) => dayjs(e.data_fim).format("DD/MM/YYYY"),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (_, e) => array_status[e.status],
      renderText: (e) => array_status[e.status],
    },
    {
      title: "Gerado",
      dataIndex: "status_gerado",
      render: (_, e) =>
        e.status_gerado === 1 ? <Text type="success">Gerado</Text> : <Text type="danger">Não Gerado</Text>,
      renderText: (e) => (e.status_gerado === 1 ? "Gerado" : "Não Gerado"),
    },
    {
      dataIndex: "acoes",
      title: "Ações",
      width: 50,
      sorter: false,
      render: (_, e) => {
        const items = [
          {
            key: "1",
            label: "Localidades",
            icon: <BarsOutlined />,
            onClick: () => navigate(`/eleicoes-cipa/eleicoes/localidades/${e?.id}`),
          },
          {
            key: "2",
            label: "Gerar",
            icon: <RedoOutlined />,
            onClick: () => {
              modal.confirm({
                title: "Deseja gerar os eleitores?",
                okText: "Sim",
                cancelText: "Cancelar",
                onOk() {
                  gerarEleitores(e.id);
                },
              });
            },
          },
          {
            key: "3",
            label: "Eleitores",
            icon: <UserOutlined />,
            onClick: () => navigate(`/eleicoes-cipa/eleicoes/eleitores/${e?.id}`),
          },
          {
            key: "4",
            label: "Resultados",
            icon: <FileDoneOutlined />,
            onClick: () => navigate(`/eleicoes-cipa/eleicoes/resultados/${e?.id}`),
          },
        ];

        return (
          <Space.Compact>
            <Dropdown menu={{ items }}>
              <Button loading={loading} icon={<MoreOutlined />} />
            </Dropdown>

            <Tooltip title="Editar">
              <Button loading={loading} onClick={() => carregarEleicao(e.id)} icon={<EditOutlined />} />
            </Tooltip>
            <Tooltip title="Excluir">
              <Button
                danger
                loading={loading}
                icon={<DeleteOutlined />}
                onClick={() => {
                  modal.confirm({
                    title: "Deseja deletar este registro?",
                    okText: "Sim",
                    cancelText: "Cancelar",
                    onOk() {
                      deletarEleicao(e.id);
                    },
                  });
                }}
              />
            </Tooltip>
          </Space.Compact>
        );
      },
      dataIndex: "acoes",
    },
  ];

  // SUBMIT FORM
  const onSubmit = (formulario) => {
    formulario.data_inicio = dayjs(formulario.data_inicio).format("YYYY-MM-DD");
    formulario.data_fim = dayjs(formulario.data_fim).format("YYYY-MM-DD");

    if (idAlt > 0) {
      formulario.id = idAlt;
      alterarEleicao(formulario);
    } else {
      cadastrarEleicao(formulario);
    }
  };

  // FORMULÁRIO
  const modalFormulario = (
    <Modal
      title={
        <Text style={{ fontSize: 20 }}>
          <EditOutlined /> {idAlt > 0 ? "Editar" : "Adicionar"} Eleição
        </Text>
      }
      open={showModal}
      onOk={() => form.submit()}
      okText="Salvar"
      width={1000}
      okButtonProps={{ size: "large", loading: loading }}
      cancelButtonProps={{ size: "large", loading: loading }}
      onCancel={() => {
        setShowModal(false);
        resetForm();
      }}>
      <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item name="descricao" label="Descrição" rules={[{ required: true, message: "Digite a descrição!" }]}>
              <Input size="large" disabled={loading} placeholder="Informe a descrição" />
            </Form.Item>
          </Col>
          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item name="ano" label="Ano" rules={[{ required: true, message: "Digite a descrição!" }]}>
              <InputNumber
                min={2020}
                className="input-number"
                max={2100}
                step={1}
                size="large"
                disabled={loading}
                placeholder="Informe a descrição"
              />
            </Form.Item>
          </Col>
          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item
              name="data_inicio"
              label="Data Início"
              rules={[{ required: true, message: "Selecione a data!" }]}>
              <DatePicker format="DD/MM/YYYY" style={{ width: "100%" }} size="large" disabled={loading} />
            </Form.Item>
          </Col>

          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item name="data_fim" label="Data Fim" rules={[{ required: true, message: "Selecione a data!" }]}>
              <DatePicker format="DD/MM/YYYY" style={{ width: "100%" }} size="large" disabled={loading} />
            </Form.Item>
          </Col>

          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item name="status" label="Status" rules={[{ required: true, message: "Selecione o status!" }]}>
              <Select
                size="large"
                placeholder="Selecione o status"
                disabled={loading}
                style={{ width: "100%" }}
                options={options_status}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );

  return (
    <Row align="middle" justify="center" className="content-row">
      {modalFormulario}
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Eleições CIPA" onClickBack={() => navigate(to)} />
            <HeaderTitle
              title="Eleições"
              subtitle="Cadastro de Eleições"
              icon={<ScheduleOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <TableCustom
                extraHeaderComponents={
                  <Tooltip title="Adicionar Registro">
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={() => {
                        setShowModal(true);
                        resetForm();
                      }}
                      loading={loading}>
                      Novo
                    </Button>
                  </Tooltip>
                }
                loading={loading}
                columns={columns}
                dataSource={dados}
              />
            </Card>
          </div>
        </Col>
      </Col>
      {contextHolder}
    </Row>
  );
};
